import { render } from "./Widget.vue?vue&type=template&id=5dc87cfc&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=5dc87cfc&scoped=true&lang=scss"

import exportComponent from "D:\\LTG Sercices\\SUP-H\\suph-adhesion-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc87cfc"]])

export default __exports__